import {InfoCircleOutlined, PlusOutlined} from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Divider,
  Empty,
  Layout,
  Result,
  Skeleton,
  Table,
  notification,
  theme
} from "antd";
import {useEffect, useState} from "react";
import { Link, useNavigate } from "react-router-dom";
import {apiGroupsList} from "../../../../api/groups";
import { useIsMobileHook } from "../../../../utils/WindowHooks";
import "./GroupsListing.scss";

const { Content } = Layout;

const GroupsListing = () => {
  const [dataGroups, setDataGroups] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const isMobile = useIsMobileHook(1600);
  const [filteredData, setFilteredData] = useState(dataGroups?.results);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const navigate = useNavigate();
  const [activeError, setActiveError] = useState(false);
  const [errorStatus, setErrorStatus] = useState("");

  const handleRowClick = (record) => {
    const id = record.id;
    const newExpandedRowKeys = [...expandedRowKeys];
    const index = newExpandedRowKeys.indexOf(id);
    if (index > -1) {
      newExpandedRowKeys.splice(index, 1);
    } else {
      newExpandedRowKeys.push(id);
    }
    setExpandedRowKeys(newExpandedRowKeys);
  };

  useEffect(() => {
    fetchData({
      page: 1,
    });
  }, []);

  const fetchData = async (params) => {
    setIsFetching(true);
    try {
      const filteredParams = Object.fromEntries(
        Object.entries(params).filter(([_, value]) => value !== undefined && value !== null && value !== '')
      );
      const json = await apiGroupsList(filteredParams);
      setDataGroups(json);
      setFilteredData(json.results);
      setPagination((prevPagination) => ({
        ...prevPagination,
        total: json.count,
        current: params.page,
      }));
    } catch (error) {
      setActiveError(true);
      setErrorStatus(error.status);
      notification.error({
        message: "Erro",
        description: "Ocorreu um erro ao buscar os perfis.",
        placement: "topRight",
      });
    } finally {
      setIsFetching(false);
    }
  };

  const onChangePage = (pagination) => {
    fetchData({
      page: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  const columns = [
    {
      title: "Nome",
      dataIndex: "name",
      key: "name",
      onCell: () => ({
        style: { cursor: "pointer" },
      }),
      render: (name) => (
        <p
          style={{ textTransform: "capitalize" }}
        >
          {name}
        </p>
      ),
    },
    {
      title: "Número de Permissões",
      dataIndex: "permission_count",
      key: "permission_count",
      responsive: ["sm"],
    },
    {
      title: "Ações",
      dataIndex: "",
      key: "actions",
      render: (group) => (
        <div style={{ display: 'flex', gap: '8px' }}>
          <Link to={`/perfis/${group.id}`}>
            <Button type="text" icon={<InfoCircleOutlined />} title="Visualizar" />
          </Link>
        </div>
      ),
      responsive: ["lg"],
    },
  ];

  const expandedRowRender = (record) => (
    <div className="expandid">
      <span>
        Nome:{" "}
        <p>{record.name}</p>
      </span>
      <span>
        Permissões:{" "}
        <p>{record.permissions ? record.permissions.length : 0}</p>
      </span>
      <span style={{ marginTop: "10px" }}>
        Ações:{" "}
        <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
          <Link to={`/perfis/${record.id}`}>
            <Button size="small" icon={<InfoCircleOutlined />}>Visualizar</Button>
          </Link>
        </div>
      </span>
    </div>
  );

  const locale = {
    emptyText: <Empty description="Sem dados" />,
  };

  const renderError = (status) => {
    if (activeError) {
      return (
        <Result
          status={status === "500" ? "500" : "404"}
          title={status}
          subTitle={
            status === "500"
              ? "Ocorreu um erro no servidor, tente novamente mais tarde."
              : "Ocorreu um erro, tente novamente mais tarde."
          }
          extra={
            <Button onClick={() => navigate("/")} type="primary">
              Dashboard
            </Button>
          }
        />
      );
    }
  };

  return (
    <div className="GroupsListing">
      <Layout
        style={{
          padding: "1.25rem",
        }}
      >
        <Breadcrumb
          style={{
            margin: "16px 0",
          }}
        >
          <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center" }}>
            <h2 className="title-page">Perfis</h2>
            <Button 
              type="primary" 
              icon={<PlusOutlined />}
              onClick={() => navigate("/perfis/criar")}
            >
              Criar Perfil
            </Button>
          </div>
          <Divider />
          <Breadcrumb.Item>Sistema</Breadcrumb.Item>
          <Breadcrumb.Item>Perfis</Breadcrumb.Item>
        </Breadcrumb>
        <Content
          style={{
            padding: 24,
            margin: 0,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <h3 className="subtitle-page">Listagem de perfis</h3>
          <Divider />
          {isFetching ? (
            <Skeleton active />
          ) : activeError ? (
            renderError(errorStatus)
          ) : (
            <Table
              columns={columns}
              locale={locale}
              expandable={{
                expandedRowRender: isMobile ? expandedRowRender : undefined,
                expandedRowKeys: expandedRowKeys,
                onExpand: (expanded, record) => handleRowClick(record),
                responsive: ["xl"],
              }}
              dataSource={
                filteredData &&
                filteredData.map((item) => ({ ...item, key: item.id }))
              }
              pagination={{
                current: pagination.current,
                total: pagination.total,
                pageSize: pagination.pageSize,
                showSizeChanger: false,
              }}
              bordered
              onChange={onChangePage}
            />
          )}
        </Content>
      </Layout>
    </div>
  );
};

export default GroupsListing;